import Decimal from 'decimal.js';
import { Path } from 'react-hook-form';

export interface DSUEFormShape {
  id?: string;
  primaryClientId: string;
  amount: Decimal;
  asOfDate: Date;
  notes?: string;
  documents: string[];
}

export type DSUEFormShapePaths = Path<DSUEFormShape>;

export const initialFormValues: DSUEFormShape = {
  primaryClientId: '',
  amount: new Decimal(0),
  asOfDate: new Date(),
  notes: '',
  documents: [],
};
